module.exports = __webpack_public_path__ + "assets/79ea3ccce3dea9031c736592bb004723.mp3";